import React from 'react';
import T from 'i18n-react';
import Typography from '@material-ui/core/Typography';

const Itinerary = ({ index }: { index: number }) => (
  <Typography component="span" variant="inherit" color="textSecondary">
    {T.translate('plan.itinerary')}
    {index + 1}
  </Typography>
);

export default Itinerary;
